<!--
 * @Description: 学生多条查找带回
 * @Author: PF
 * @Date: 2023-02-03 15:00:22
 * @LastEditors: PF
 * @LastEditTime: 2025-06-18 11:57:33
-->
<template>
  <div class="cha-zhao-duo-tiao">
    <el-dialog style="min-width: 770px;" class="wp70 hp70" :model-value="openDuoTiao" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <span class="header-title">学生</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDuoTiao', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-row style="height: 100%;">
        <el-col :span="11" style="height: 100%">
          <el-container>
            <!-- 搜索区域 END -->
            <el-header style="padding:0">
              <el-form class="search" :model="dataGrid.parms" @submit.enter.prevent>
                <el-row :gutter="10">
                  <el-col :span="12">
                    <el-form-item>
                      <el-input placeholder="学号/姓名" v-model="dataGrid.parms.keyword" clearable @clear="initLeftList()" @keyup.enter="initLeftList()">
                        <template #suffix>
                          <el-icon class="el-input__icon pointer" @click="initLeftList()">
                            <search />
                          </el-icon>
                        </template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="系部" v-model="dataGrid.parms.xbid" clearable filterable :teleported="false" @change="initZhuanYe();initLeftList()">
                        <el-option v-for="item in xbData" :key="item.id" :label="item.jgmc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="层次" v-model="dataGrid.parms.ccid" clearable filterable :teleported="false" @change="initZhuanYe();initLeftList()">
                        <el-option v-for="item in ccData" :key="item.id" :label="item.bt" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="专业" v-model="dataGrid.parms.zyid" clearable filterable :teleported="false" @change="initBanJi();initLeftList()">
                        <el-option v-for="item in zyData" :key="item.id" :label="item.zymc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="年级" v-model="dataGrid.parms.njid" clearable filterable :teleported="false" @change="initBanJi();initLeftList()">
                        <el-option v-for="item in njData" :key="item.id" :label="item.njmc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-select placeholder="班级" v-model="dataGrid.parms.bjid" clearable filterable :teleported="false" @change="initLeftList()">
                        <el-option v-for="item in bjData" :key="item.id" :label="item.xzbmc" :value="item.id" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item>
                      <el-button class="wp100" type="success" @click="openGaoJiChaXunXueSheng=true"><span class="el-icon--left iconfont icon-sousuo" :style="dataGrid.parms.gaoJiQuery?'color:#ff0':''"></span>高级查询</el-button>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-header>
            <el-main style="padding:0">
              <el-table :data="dataGrid.data" border v-loading="dataGrid.loading" height="100%" @selection-change="leftSelectionChange" @row-dblclick="leftRowDblclick">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
                <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
                  <template #default="scope">
                    <el-link type="primary" @click="openDetail=true;row={xsid:scope.row.id,xm:scope.row.xm}">{{scope.row.xm}}</el-link>
                  </template>
                </el-table-column>
                <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip />
                <el-table-column width="55" align="center" show-overflow-tooltip>
                  <template #default="scope">
                    <el-button link type="primary" @click.stop="leftRowDblclick(scope.row)">
                      <span class="iconfont icon-youjiantou"></span>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-col>
        <el-col :span="2" style="height: 100%">
          <div class="but_group">
            <span class="iconfont icon-shuangjiantouzuo" @click="toLeftClick"></span>
            <span class="iconfont icon-shuangjiantouyou" @click="toRightClick"></span>
          </div>
        </el-col>
        <el-col :span="11" style="height: 100%">
          <el-table :data="rightTableData" border v-loading="dataGrid.loading" height="100%" @selection-change="rightSelectionChange" @row-dblclick="rightRowDblclick">
            <el-table-column type="selection" align="center" width="55" />
            <el-table-column width="55" fixed align="center" show-overflow-tooltip>
              <template #default="scope">
                <el-button link type="primary" :disabled="!scope.row.id" @click.stop="rightRowDblclick(scope.row)">
                  <span class="iconfont icon-zuojiantou"></span>
                </el-button>
              </template>
            </el-table-column>
            <el-table-column label="学号" prop="xh" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']" />
            <el-table-column label="姓名" prop="xm" fixed align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']">
              <template #default="scope">
                <el-link type="primary" @click="openDetail=true;row={xsid:scope.row.id,xm:scope.row.xm}">{{scope.row.xm}}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="性别" prop="xb" align="center" show-overflow-tooltip />
          </el-table>
        </el-col>
      </el-row>

      <template #footer>
        <div class="dialog-footer">
          <el-row style="width: 100%">
            <el-col :span="11">
              <pagination :pagination="dataGrid.pagination" @ReturnData="initLeftList" />
            </el-col>
            <el-col :span="2">
            </el-col>
            <el-col :span="11" style="display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;">共 {{ rightTableData.length }} 条</span>
              <div class="footer_but mr0">
                <el-button type="primary" @click="savestudent()">选择</el-button>
                <el-button type="info" @click="closeWindow('openDuoTiao', emits, false)">关闭</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
  <gaojichaxunxuesheng  v-if="openGaoJiChaXunXueSheng" v-model:openGaoJi="openGaoJiChaXunXueSheng" :row="dataGrid.parms.gaoJiQuery" @ReturnData="xueShengGaoJiRet" />
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { closeWindow, loadList, actionPost, loadSelect } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'
import pagination from '@/components/pagination.vue'
import detail from '@/components/xuesheng/detail'
import gaojichaxunxuesheng from '@/components/gaojichaxun/xuesheng.vue'

const props = defineProps({
  openDuoTiao: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDuoTiao', 'ReturnData'])
const row = ref({ ids: [] })

const rightTableData = ref([]) // 右侧列表
const leftMultipleSelection = ref([]) // 左侧多选
const rightMultipleSelection = ref([]) // 右侧多选
const savestudent = () => {
  emits('ReturnData', rightTableData.value)
  closeWindow('openDuoTiao', emits, false)
}
const openDetail = ref(false)

// 学生高级查询
const openGaoJiChaXunXueSheng = ref(false)
const xueShengGaoJiRet = (data) => {
  dataGrid.value.parms = {}
  if (data.length !== 0) {
    dataGrid.value.parms.gaoJiQuery = data
  }
  initLeftList()
}

// 双击左侧列表
const leftRowDblclick = (row) => {
  leftMultipleSelection.value.push(row)
  toRightClick()
}
// 双击右侧列表
const rightRowDblclick = (row) => {
  rightMultipleSelection.value.push(row)
  toLeftClick()
}
// 左箭头
const toLeftClick = () => {
  if (rightMultipleSelection.value.length) {
    rightMultipleSelection.value.forEach((element) => {
      dataGrid.value.data.unshift(element)
      rightTableData.value.forEach((e, index) => {
        if (e.id === element.id) {
          rightTableData.value.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      row.value.ids = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    rightMultipleSelection.value = []
  }
}
// 右箭头
const toRightClick = () => {
  if (leftMultipleSelection.value.length) {
    leftMultipleSelection.value.forEach((element) => {
      rightTableData.value.push(element)
      dataGrid.value.data.forEach((e, index) => {
        if (e.id === element.id) {
          dataGrid.value.data.splice(index, 1)
        }
      })
    })
    if (rightTableData.value) {
      row.value.ids = rightTableData.value.map((item) => item.id)
    }
    initLeftList()
    initRightList()
    leftMultipleSelection.value = []
  }
}
// 左侧复选框
const leftSelectionChange = (val) => {
  leftMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      leftMultipleSelection.value.push(element)
    })
  }
}
// 右侧复选框
const rightSelectionChange = (val) => {
  rightMultipleSelection.value = []
  if (val.length) {
    val.forEach((element) => {
      rightMultipleSelection.value.push(element)
    })
  }
}

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {
    pagerCount: 5,
    layout: 'prev, pager, next, total'
  },
  loading: false,
  orderBy: { prop: 'xh', order: 'ascending' }, // ['ascending', 'descending']
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    initLeftList()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map((item) => item.id)
  }
})
const initLeftList = async (pageNo, pageSize) => {
  dataGrid.value.parms.notInIDs = row.value.ids
  loadList({
    url: '/api/v2/pdp/xuesheng/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    pagerCount: 5,
    layout: 'prev, pager, next, total',
    dataGrid: dataGrid.value,
    loadSuccess: function (res) {
      dataGrid.value.multipleSelection = []
      dataGrid.value.data = res.data.total === 0 ? [] : res.data.list
    }
  })
}

const initRightList = async () => {
  rightTableData.value = []
  dataGrid.value.loading = true
  const o = {
    url: '/api/v2/pdp/xuesheng/list',
    data: {
      order: 'xh',
      sort: 'asc',
      inIDs: row.value.ids,
      menuId: sessionStorage.getItem('menuId')
    }
  }
  actionPost(o).then((res) => {
    dataGrid.value.loading = false
    rightTableData.value = res.data // 返回列表
  })
}

// 加载 系部 下拉框
const xbData = ref()
// 加载 层次 下拉框
const ccData = ref()

// 加载 专业 下拉框
const zyData = ref()
const initZhuanYe = () => {
  loadSelect({
    url: '/api/v2/pdp/zhuanye/list',
    data: zyData,
    parms: {
      xbid: dataGrid.value.parms.xbid,
      ccid: dataGrid.value.parms.ccid
    },
    order: 'zymc',
    sort: 'asc'
  })
}

// 加载 年级 下拉框
const njData = ref()

// 加载 班级 下拉框
const bjData = ref()
const initBanJi = () => {
  loadSelect({
    url: '/api/v2/pdp/banji/list',
    data: bjData,
    parms: {
      zyid: dataGrid.value.parms.zyid,
      njid: dataGrid.value.parms.njid
    },
    order: 'xzbmc',
    sort: 'asc'
  })
}

watch(
  () => props.openDuoTiao,
  () => {
    if (props.openDuoTiao) {
      row.value = props.row || {}
      loadSelect({ url: '/api/v2/xiaoneijigou/listxibu', data: xbData, order: 'jgh', sort: 'asc' })
      loadZiDianSelect('层次', ccData, 'sx', 'asc')
      loadSelect({ url: '/api/v2/pdp/nianji/list', data: njData, order: 'njdm', sort: 'asc' })
      initLeftList()
      initRightList()
      initZhuanYe()
      initBanJi()
    }
  },
  { deep: true, immediate: true }
)
</script>

<style lang="less" scoped>
:deep(.filter-item) {
  width: 150px;
}
.search {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-button {
    margin: 0;
  }
}
:deep(.el-radio__label) {
  display: none;
}
:deep(.el-tabs__content) {
  display: none;
}
.el-tabs {
  height: 55px;
}
:deep(.but_group) {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  .iconfont {
    font-size: 1.5rem;
    cursor: pointer;
  }
}
.e-row {
  height: 100%;
}
</style>
